import React, { useState, useEffect, useRef, useCallback } from 'react';
import { FaStar, FaQuoteRight, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const intervalRef = useRef(null);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [mouseStart, setMouseStart] = useState(0);
  const [mouseEnd, setMouseEnd] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [slideDirection, setSlideDirection] = useState('');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const testimonials = [
    {
      id: 1,
      name: 'פיקוד העורף',
      content: 'ליהי הוכיחה הישגים מרשימים בסיוע והשקעה ברמה הכי גבוהה שיש. היא חיברה בין חיילים ומפקדים והנגישה את התוכן עד לאחרון החיילים. מקצועיות וחדשנות ברמה הגבוהה ביותר.',
      rating: 5,
      image: 'testimonial-1'
    },
    {
      id: 2,
      name: 'תמי כ.',
      content: 'ליהי הפכה את העסק שלי! התוכן שלה יצירתי ומקצועי, והתוצאות מדברות בעד עצמן. המכירות שלי עלו ב-300% תוך 3 חודשים.',
      rating: 5,
      image: 'testimonial-2'
    },
    {
      id: 3,
      name: 'רוחמה א.',
      content: 'עבודה מדהימה! ליהי הבינה בדיוק מה אני צריכה ויצרה תוכן שפשוט מושלם. השירות האישי והמקצועיות ברמה הכי גבוהה.',
      rating: 5,
      image: 'testimonial-3'
    },
    {
      id: 4,
      name: 'דניאלה נ.',
      content: 'ליהי לא רק יצרה תוכן מעולה, היא ליוותה אותי בכל שלב. הגישה החדשנית שלה והיכולת להביא טרנדים חדשים פשוט מדהימה.',
      rating: 5,
      image: 'testimonial-4'
    },
    {
      id: 5,
      name: 'קרין ל.',
      content: 'ליהי יצרה עבורי קמפיין שיווקי שפשוט הרים את העסק לרמה אחרת. היצירתיות והמקצועיות שלה מדהימות.',
      rating: 5,
      image: 'testimonial-5'
    },
    {
      id: 6,
      name: 'אור ג.',
      content: 'התוכן שליהי יוצרת הוא פשוט מושלם! כל פוסט מקבל המון תגובות ושיתופים. היא באמת מבינה איך לחבר עם הקהל.',
      rating: 5,
      image: 'testimonial-6'
    },
    {
      id: 7,
      name: 'גלית כ.',
      content: 'ליהי הפכה את הדף שלי מדף רגיל לדף שמושך אלפי עוקבים. השירות שלה מעבר למצופה!',
      rating: 5,
      image: 'testimonial-7'
    },
    {
      id: 8,
      name: 'אופק מ.',
      content: 'עבדתי עם הרבה מעצבים, אבל ליהי היא משהו אחר לגמרי. היא מבינה בדיוק מה אני רוצה ומביאה את זה לחיים.',
      rating: 5,
      image: 'testimonial-8'
    },
    {
      id: 9,
      name: 'שירה ב.',
      content: 'העבודה עם ליהי שינתה את האסטרטגיה הדיגיטלית שלנו לחלוטין!',
      rating: 5,
      image: 'testimonial-9'
    },
    {
      id: 10,
      name: 'יוסי ר.',
      content: 'תוצאות מעבר לציפיות! ליהי הבינה את הצרכים העסקיים שלי.',
      rating: 5,
      image: 'testimonial-10'
    },
    {
      id: 11,
      name: 'מיכל ש.',
      content: 'יצירתיות ללא גבולות. ליהי תמיד מפתיעה בחיוב!',
      rating: 5,
      image: 'testimonial-11'
    },
    {
      id: 12,
      name: 'דוד ל.',
      content: 'המעורבות בדפים שלנו עלתה פי 3 תודות לליהי!',
      rating: 5,
      image: 'testimonial-12'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const nextTestimonial = useCallback(() => {
    if (isTransitioning) return;
    setSlideDirection('left');
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
      setSlideDirection('');
      setTimeout(() => setIsTransitioning(false), 50);
    }, 300);
  }, [isTransitioning, testimonials.length]);

  const prevTestimonial = useCallback(() => {
    if (isTransitioning) return;
    setSlideDirection('right');
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
      setSlideDirection('');
      setTimeout(() => setIsTransitioning(false), 50);
    }, 300);
  }, [isTransitioning, testimonials.length]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      nextTestimonial();
    }, 8000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [nextTestimonial]);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50;
    
    if (distance > minSwipeDistance) {
      nextTestimonial();
    }
    
    if (distance < -minSwipeDistance) {
      prevTestimonial();
    }
    
    setTouchStart(0);
    setTouchEnd(0);
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setMouseStart(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setMouseEnd(e.clientX);
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    setIsDragging(false);
    
    if (!mouseStart || !mouseEnd) return;
    
    const distance = mouseStart - mouseEnd;
    const minDragDistance = 50;
    
    if (distance > minDragDistance) {
      nextTestimonial();
    }
    
    if (distance < -minDragDistance) {
      prevTestimonial();
    }
    
    setMouseStart(0);
    setMouseEnd(0);
  };

  const handleMouseLeaveWhileDragging = () => {
    if (isDragging) {
      setIsDragging(false);
      setMouseStart(0);
      setMouseEnd(0);
    }
  };

  return (
    <section id="testimonials" className="testimonials section" ref={sectionRef}>
      <div className="container">
        <div className={`testimonials-header ${isVisible ? 'fade-in' : ''}`}>
          <h2 className="heading-lg">
            מה <span className="gradient-text highlight-yellow">הלקוחות אומרים</span> עליי?
          </h2>
          <p className="text-lg">
            ביקורות אמיתיות מלקוחות מרוצים שחוו את השירות המקצועי שלי.
          </p>
        </div>

        <div className={`testimonials-content ${isVisible ? 'slide-in-up' : ''}`}>
          <div className="testimonial-navigation">
            <button 
              onClick={prevTestimonial}
              className="nav-btn nav-prev"
              aria-label="Previous testimonial"
            >
              <FaArrowRight />
            </button>
            <button 
              onClick={nextTestimonial}
              className="nav-btn nav-next"
              aria-label="Next testimonial"
            >
              <FaArrowLeft />
            </button>
          </div>

          <div 
            className="testimonial-display"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeaveWhileDragging}
          >
            <div 
              className={`testimonial-card ${slideDirection ? `slide-out-${slideDirection}` : 'slide-in'}`}
            >
              <div className="quote-icon">
                <FaQuoteRight />
              </div>
              
              <div className="testimonial-rating">
                {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                  <FaStar key={i} className="star-icon" />
                ))}
              </div>

              <blockquote className="testimonial-content">
                "{testimonials[activeTestimonial].content}"
              </blockquote>

              <div className="testimonial-author">
                <div className="author-avatar">
                  <div className="avatar-placeholder">
                    {testimonials[activeTestimonial].name.charAt(0)}
                  </div>
                </div>
                <div className="author-info">
                  <h4 className="author-name">{testimonials[activeTestimonial].name}</h4>
                </div>
              </div>
            </div>
          </div>

          <div className="testimonial-indicators">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === activeTestimonial ? 'active' : ''}`}
                onClick={() => setActiveTestimonial(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
